var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"recomended-list"},_vm._l((_vm.recomended_videos),function(video_2){return _c('div',{key:video_2.id.videoId},[_c('RecomendedBox',{attrs:{"video_2":video_2}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }